/**
 * Created by Ning Jiang on 10/10/2018.
 */

import {Presentation, PresentationState} from "@nolimitcity/slot-game/bin/core/gamecontroller/presentations/Presentation";
import {WGParsedGameData} from "../../../server/data/WGParsedGameData";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {IBetLineWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {WarriorGraveyardGameModuleConfig} from "../../../WarriorGraveyardGameModuleConfig";
import {TimelineMax} from "gsap";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {WGGameAssets} from "../../../WGGameAssets";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {WGParsedInitData} from "../../../server/data/WGParsedInitData";
import {MathHelper} from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import {WGGameConfig} from "../../../WGGameConfig";
import {WGEngineManager} from "../../../engine/WGEngineManager";
import {IReelSymbolStates, WGSpriteSymbol} from "../../../engine/Symbol/WGSpriteSymbol";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {BigWinPrsentation} from "../bigwin/BigWinPrsentation";

export class WGLastPresentation extends Presentation {
    private _individualData: WGParsedGameData;
    private _betWinAmount: PIXI.BitmapText;
    private _betWinMultiplier: PIXI.BitmapText;
    private _warriorMultiplier: number;
    private _winAmountShadow: PIXI.Sprite;
    private _symWinStates: boolean[][] = [];
    private _warriorFeatureAmount: PIXI.BitmapText;
    private _tl: TimelineMax;
    private _warriorAmount_tl: TimelineMax;
    private _isWin: boolean = false;

    public initialization(): void {
        this._warriorAmount_tl = new TimelineMax();
        this._winAmountShadow = this._winAmountShadow = new PIXI.Sprite(GameResources.getTextures(WGGameAssets.WIN_AMOUNT_SHADOW)[0]);
        this._winAmountShadow.scale.set(3, 3);
        this._winAmountShadow.anchor.set(0.5);
        this._betWinAmount = new PIXI.BitmapText("0", {
            fontName: "WGNumbersWinCountUp",
            fontSize: 10
        });
        this._warriorFeatureAmount = new PIXI.BitmapText("0", {
            fontName: "WGNumbersWinCountUp",
            fontSize: 25
        });
        this._betWinMultiplier = new PIXI.BitmapText("0", {
            fontName: "WGNumbersWinCountUp",
            fontSize: 8
        });
    }

    public setParsedInitData(data: WGParsedInitData): void {
        if (data.mode == GameMode.NORMAL) {
            this.PresentationState.set(PresentationState.ACTIVATED);
        }
    }

    public checkForActivation(data: WGParsedGameData): boolean {
        this._isWin = (data.betWins.length > 0 || data.triggerWarriorPay);
        return data.nextMode === GameMode.NORMAL;
    }

    public setParsedGamedData(data: WGParsedGameData): void {
        this._individualData = data;
        this._warriorMultiplier = data.warriorMultiplier;
        this._symWinStates = data.symbolWinStates;
        this._warriorFeatureAmount.text = (data.warriorPayout).toFixed(2).toString();
    }

    public getPresentation(): void {
        this.PresentationState.set(PresentationState.END);
        if (this._isWin) {
            this.undimWinningSymbols();
            const initialDelay: number = BigWinPrsentation._skippedOnLastLevel ? 1.5 : 0.5; // to fix # 343, #340
            //  make sure to hide stack if we have normal wins only
            (this._individualData.betWins.length) && EventHandler.dispatchEvent(new GameEvent("HIDE_M_STACKS", true));
            this._tl = new TimelineMax({
                repeat: -1,
                repeatDelay: 1
            });

            const betlineWin = this._individualData.betWins as IBetLineWinData[];
            for (let i: number = 0; i < betlineWin.length; i++) {
                this._tl.add(() => {
                    WarriorGraveyardGameModuleConfig.betlineWinBox.hideAllWinBox();
                    WarriorGraveyardGameModuleConfig.betlineWinBox.hideAllBetlines();
                    WarriorGraveyardGameModuleConfig.betlineWinBox.playWinBoxAnimation([betlineWin[i]],
                        this._individualData!.currentWinRatioConfig?.text),
                        this.showBetWinAmount(betlineWin[i].betLineIndex)
                }, initialDelay + (i * 2));
                if (i === betlineWin.length - 1) {
                    this._tl.add(() => {
                    }, initialDelay + (betlineWin.length * 2));
                }
            }
            // showing warrior toggle from here
            let reelsToShowWinBoxes: number[] = [];
            for (let i = 0; i < WGGameConfig.instance.REEL_ENGINE_CONFIG.REEL_AMOUNT; i++) {
                if (this._individualData.activeWarriorSymbolReel[i] || this._individualData.wildMultipliers[i] > 0 || this._individualData.lockedWildReelsAfter[i]) {
                    reelsToShowWinBoxes.push(i);
                }
            }
            if (reelsToShowWinBoxes.length && this._individualData.triggerWarriorPay) {
                if (!this._individualData.betWins.length) { // when there is only warrior win
                    this._tl.to({}, initialDelay, {});
                }
                this.playWarriorToggle(reelsToShowWinBoxes);
            }
        } else {
            this.playIdleAnimation();
        }
    }

    private playWarriorToggle(reelsToShowWinBoxes: number[]): void {
        this._tl.add(() => {
            this._betWinAmount.visible = false;
            this._betWinMultiplier.visible = false;
            this._winAmountShadow.visible = false;
            WarriorGraveyardGameModuleConfig.betlineWinBox.hideAllBetlines();
            WarriorGraveyardGameModuleConfig.betlineWinBox.hideAllWinBox();
        });
        this._tl.add(() => {
            EventHandler.dispatchEvent(new GameEvent("SHOW_MID_STACKS_TOGGLE"));
            this.showWarriorWinAmount();
            WarriorGraveyardGameModuleConfig.betlineWinBox.showAllBetlinesOneByOne(true);
            WarriorGraveyardGameModuleConfig.betlineWinBox.showWinBoxForWarriorFeaturePresentation(reelsToShowWinBoxes);
        });
        this._tl.to({}, 2, {});
        this._tl.add(() => {
            this.hideWarriorWinAmount();
            this._individualData.betWins.length && EventHandler.dispatchEvent(new GameEvent("HIDE_M_STACKS", true));
            WarriorGraveyardGameModuleConfig.betlineWinBox.hideAllBetlines();
            WarriorGraveyardGameModuleConfig.betlineWinBox.hideAllWinBox();
        });

        if (!this._individualData.betWins.length) {
            this._tl.to({}, 0.5, {});
        }
    }

    private playIdleAnimation(): void {
        this._tl = new TimelineMax({
            repeat: -1,
            repeatDelay: 4
        });
        this._tl.add(() => {
            const reelId: number = MathHelper.randomNumberInRange(0, WGGameConfig.instance.REEL_ENGINE_CONFIG.REEL_AMOUNT - 1);
            let symId: number = MathHelper.randomNumberInRange(0, WGGameConfig.instance.REEL_ENGINE_CONFIG.WINDOW_AMOUNT - 1);
            let symbol = WGEngineManager.getReel(reelId).getSymbol(symId) as WGSpriteSymbol;
            if (symbol.isWild) {
                WarriorGraveyardGameModuleConfig.stackAnimationPlayer.playWildStackAnimation(reelId, "_idle");
            } else if (!symbol.isScatter && !symbol.isLowValue) {
                for (let i = 0; i < WGEngineManager.getReel(reelId).AllSymbols.length; i++) {
                    if (WGEngineManager.getReel(reelId).AllSymbols[i].symName.split("*")[0] === symbol.symName.split("*")[0]) {
                        symId = WGEngineManager.getReel(reelId).AllSymbols[i].posID;
                        break;
                    }
                }
                // symId = WGEngineManager.getReel(reelId).AllSymbols.findIndex(value => value.symName === symbol.symName);
                WarriorGraveyardGameModuleConfig.stackAnimationPlayer.playMidStackIdleAnimation(reelId, symId, symbol.symName.split("*")[0]);
            } else {
                symbol.changeState({state: IReelSymbolStates.IDLE});
            }
        }, 2);
        this._tl.fromTo({}, 1, {}, {});
    }

    public endPresentation(): void {
        Helper.timeLineKiller(this._tl, new TimelineMax({
            onComplete: () => {
                WarriorGraveyardGameModuleConfig.betlineWinBox.hideAllWinBox();
                WarriorGraveyardGameModuleConfig.betlineWinBox.hideAllBetlines();
                WarriorGraveyardGameModuleConfig.stackAnimationPlayer.hideAllStackAnimation();
                this._betWinAmount.visible = false;
                this.hideWarriorWinAmount();
                this._betWinMultiplier.visible = false;
                this._winAmountShadow.visible = false;
            }
        }));
        this.PresentationState.set(PresentationState.INACTIVE);
    }

    private showBetWinAmount(betlineIndex: number): void {
        this._betWinAmount.visible = true;
        this._betWinMultiplier.visible = true;
        this._winAmountShadow.visible = true;
        let data: IBetLineWinData[] = this._individualData.betWins as IBetLineWinData[];
        this._betWinAmount.text = "";
        this._betWinMultiplier.text = "";
        for (let index: number = 0; index < data.length; index++) {
            if (data[index].betLineIndex === betlineIndex) {
                // bet win amount on betline
                this._betWinAmount.text = (data[index].amount.toFixed(2).toString());
                this._betWinAmount.pivot.set(this._betWinAmount.width / 2, this._betWinAmount.height / 2);
                this._betWinAmount.position.set(120 * 3, (199 * ((data[index].betLine[2]) + 1)));
                //bet win multiplier on betline
                if (data[index].multiplier > 1) { // only show multiplier if greater than 1
                    this._betWinMultiplier.text = "x" + (data[index].multiplier.toString());
                    this._betWinMultiplier.pivot.set(this._betWinMultiplier.width / 2, this._betWinMultiplier.height / 2);
                    this._betWinMultiplier.position.set(120 * 3, ((199 * ((data[index].betLine[2]) + 1)))
                        + this._betWinAmount.height * 0.7);
                }
                // shadow for mulitplier and win amount
                this._winAmountShadow.position.set(120 * 3, ((199 * ((data[index].betLine[2]) + 1))))
                this._winAmountShadow.width = this._betWinAmount.width * 2;
                this._winAmountShadow.height = this._betWinAmount.height * 3;
                this.addChild(this._winAmountShadow, this._betWinAmount, this._betWinMultiplier);
            }
        }
    }

    private undimWinningSymbols(): void {
        WGEngineManager.RAll((reel: number) => {
            for (let i: number = 0; i < 3; i++) {
                if (this._symWinStates[reel][i]) {
                    let sym = WGEngineManager.getReel(reel).getSymbol(i);
                    sym!.changeState({state: IReelSymbolStates.NORMAL});
                }
            }
        });
    }

    public stopPresentation(): void {
        this.PresentationState.set(PresentationState.END);
    }

    private hideWarriorWinAmount(): void {
        this._warriorAmount_tl.totalProgress(1);
        this._warriorAmount_tl.to(this._warriorFeatureAmount, 0.2, {
            alpha: 0
        });
        this._warriorAmount_tl.add(() => this._warriorFeatureAmount.visible = false);
    }

    private showWarriorWinAmount(): void {
        this._warriorAmount_tl.totalProgress(1);
        this._warriorAmount_tl.add(() => {
            this._warriorFeatureAmount.alpha = 1;
            this._warriorFeatureAmount.pivot.set(this._warriorFeatureAmount.width / 2, this._warriorFeatureAmount.height / 2);
            this._warriorFeatureAmount.position.set(120 * 3.2, WGGameConfig.instance.GAME_HEIGHT / 1.8);
            this.addChild(this._warriorFeatureAmount);
            this._warriorFeatureAmount.visible = true;
        });

    }
}